<div class='row'>
  <div class='col-12'>
      <form
      [formGroup]='userRoleStatusForm'
      >
        <div class="d-flex flex-wrap">
        <div class="p-2">
          <label>Role Name</label>
          <input
            type="text"
            class="form-control"
            [disabled]="loadingExport"
            formControlName="roleName"
            placeholder="Role Name"
          />
        </div>
        <div class="p-2">
          <label>Added By Text</label>
          <input
            type="text"
            class="form-control"
            [disabled]="loadingExport"
            formControlName="addedByText"
            placeholder="Added By Text"
          />
        </div>
        <div class="p-2">
          <label>Added To Text</label>
          <input
            type="text"
            class="form-control"
            [disabled]="loadingExport"
            formControlName="addedToText"
            placeholder="Added To Text"
          />
        </div>
        <div class="p-2" style="width: 200px">
          <label>Type</label>
          <kendo-dropdownlist
            [disabled]='loadingExport'
            formControlName="type"
            [data]="types">
          </kendo-dropdownlist>
        </div>
        </div>
        <button (click)="loadingUserRoleDataData()" class="ml-2 ws-loading {{reportGenerateInProgress ? 'ws-loading-progress' : ''}}">Download User Role Status</button>
      </form>
    </div>
  </div>

<div class='row mt-2'>
  <div class='col-12'>
    <form>
      <div class="d-flex flex-wrap">
        <div class="p-2">
          <label>Search</label>
          <input
            type="text"
            class="form-control"
            [disabled]="loadingExport"
            [formControl]='loginAuditControl'
            placeholder="Search"
          />
        </div>
      </div>
      <button (click)="loadingUserLoginAudit()" class="ml-2 ws-loading {{auditReportGenerateInProgress ? 'ws-loading-progress' : ''}}">Download User Login Audit</button>
    </form>
  </div>
</div>

<div class="row mt-2">
  <div class='col-12'>
  <div class="d-flex flex-wrap">
    <div style="padding: 0.5rem .5rem 0 !important;">
      <label>Download Customer CRMX Audit</label>
    </div>
  </div>
    <button (click)="loadingCustomerCrmx()" class="ml-2 ws-loading {{crmxCustomerGenerateInProgress ? 'ws-loading-progress' : ''}}">Download Customer CRMX Audit</button>
  </div>
</div>
